var symphony = symphony || {};

;
(function () {

    symphony.storiesModule = {
        localStories: [],
        wordpressStories: [],
        allStories: [],
        tmpLocalWordpressStories: [],
        allSelectedStories: ''
    };

    symphony.getRecentStories = function ($container, tagUrls) {
        setTimeout(function () {
            tagUrls = tagUrls || "";
            for(var i = 0; i < tagUrls.length; i++) {
                tagUrls[i].trim();
            }
            if (symphony.setupStoriesModuleData($container)) {
                $container[0].classList.add('local-loading');

                // get the first 6 stories from the site and from wordpress so owe can mix and match
                symphony.getLocalNewsStories(6, tagUrls, function () {
                    if (canUseWordpressFeed && wordpressFeedUrl != '') {
                        symphony.getLocalWordPressStories(6, wordpressFeedUrl, function () {
                            symphony.addStoriesSlickTemplate($container, false);
                        });
                    } else {
                        symphony.addStoriesSlickTemplate($container, true);
                    }
                });
            }
        }, 500);
    };

    symphony.getSelectedStories = function ($container, storyIds) {
        // add up the list of stories to be loaded
        if (symphony.storiesModule.allSelectedStories.indexOf(storyIds) < 0) {
            symphony.storiesModule.allSelectedStories += (symphony.storiesModule.allSelectedStories.length > 0 ? "," : "") + storyIds;
        }
        setTimeout(function () {
            if (symphony.setupStoriesModuleData($container)) {
                $container[0].classList.add('local-loading');

                symphony.getLocalNewsStories(999, "", function () {
                    if (canUseWordpressFeed && wordpressFeedUrl != '') {
                        symphony.getLocalWordPressStories(100, wordpressFeedUrl, function () {
                            symphony.addStoriesSlickTemplate($container, false, storyIds);
                        });
                    } else {
                        symphony.addStoriesSlickTemplate($container, true, storyIds);
                    }
                });
            }
        }, 500);
    };

    symphony.setupStoriesModuleData = function ($container) {

        // if (typeof hiddenPages != 'undefined') {
        //     if (!_.isNull(hiddenPages)) {
        //         if (_.indexOf(hiddenPages, 'pressreleases') !== -1) {
        //             return false;
        //         }
        //     }
        // } else {
        //     if (!_.isNull(symphony.siteSettings.data.hiddenPageTypes)) {
        //         if (_.indexOf(symphony.siteSettings.data.hiddenPageTypes, 'pressreleases') !== -1) {
        //             return false;
        //         }
        //     }
        // }

        if ($container == null || $container.length == 0) {
            return false;
        }

        $container.html('');

        if ($container.hasClass('slick-initialized')) {
            $container.slick('unslick');
        }

        if (canUseWordpressFeed && typeof wordpressFeedUrl == 'undefined') {
            var wordPress = $.grep(property.data, function (x) {
                return x.name == "wordpressfeed";
            })[0];
            if (wordPress) {
                window.wordpressFeedUrl = JSON.parse(wordPress.value).text;
            }
        }

        return true;
    };

    symphony.getLocalNewsStories = function (limit, tagIds, callback) {
        tagIds = tagIds || "";
        var tagsParam = '';
        if (tagIds.length > 0) {
            tagsParam = '?tag=' + tagIds + '&inclusiveTags=true';
        }

        // if there are ANY selected stories, we need to load the max number of stories just in case
        if (symphony.storiesModule.allSelectedStories.length > 0) {
            limit = 999;
        }
        var stories = []
        symphony.storiesModule.localStories = [];
        symphony.storiesModule.allStories = [];


        $.ajax({
            url: '/' + siteUrlAlias + '/news/json/all/false/0/' + limit + tagsParam,
            dataType: 'json',
            type: 'GET',
            cache: false,
            success: function (response) {
                _.each(response.objects, function (story) {
                    if (!story.published) {
                        return;
                    } else {
                        stories.push(story);
                    }
                });
                
                symphony.storiesModule.localStories = stories;
                symphony.wordpressFeed.localStories.activeDocs = JSON.parse(JSON.stringify(symphony.storiesModule.localStories));
                callback();
            },
            fail: function () {
                if (symphony.wordpressFeed.localLoadTries < 10) {
                    setTimeout(function () {
                        symphony.wordpressFeed.getLocalStories();
                    }, 300);
                    symphony.wordpressFeed.localLoadTries++;
                }
            }
        });
    };

    symphony.getLocalWordPressStories = function (limit, wordpressFeedUrl, callback) {
        // if there are ANY selected stories, we need to load the max number of stories just in case
        if (symphony.storiesModule.allSelectedStories.length > 0) {
            limit = 100;
        }
        if (symphony.wordpressFeed.waitingForResponse) {
            setTimeout(function () {
                symphony.getLocalWordPressStories(limit, wordpressFeedUrl, callback);
            }, 500);
        } else if (symphony.storiesModule.wordpressStories.length == 0) {
            if (symphony.wordpressFeed.pageNumber != null) {
                symphony.wordpressFeed.pageNumber++;
                wordpressFeedUrl = wordpressFeedUrl + (wordpressFeedUrl.indexOf('?') > -1 ? '&' : '?') + 'per_page=' + limit + '&page=1';
                var baseUrl = wordpressFeedUrl.split('/v2')[0] + '/v2';

                symphony.wordpressFeed.waitingForResponse = true;

                // GETTING WordPress Stories set by Local Admin
                $.get(wordpressFeedUrl, function (stories) {
                    symphony.storiesModule.tmpLocalWordpressStories = stories;
                    var promises_stories = [];

                    // Additional call to get the Featured Image for each post
                    for (var i = 0; i < symphony.storiesModule.tmpLocalWordpressStories.length; i++) {
                        var story = symphony.storiesModule.tmpLocalWordpressStories[i];
                        story.title = story.title.rendered;
                        story.description = story.excerpt.rendered;
                        story.publishDate = story.date;
                        delete story.author;

                        // only load images if:
                        // 1) the story is one of the selected ones
                        // 2) the story is one of the first 6
                        if (symphony.storiesModule.allSelectedStories.indexOf(story.id) > -1 || i < 6) {
                            // this is a USC Northern Division community news post
                            // should have access to the news_image ACF
                            if (story.news_image && story.news_image != '') {
                                story.headerImage = story.news_image;
                            } else if (story.featured_media && story.featured_media != 0) {
                                promises_stories.push($.get(baseUrl + '/media/' + story.featured_media)
                                    .done(function (data) {

                                        var story = $.grep(symphony.storiesModule.tmpLocalWordpressStories, function (x) {
                                            return x.featured_media == data.id;
                                        })[0];
                                        if (story) {
                                            story.media = data;
                                            story.headerImage = story.media ? story.media.source_url : null;
                                        }
                                    }));
                            } else if (story.link.indexOf('community-news') > -1) {
                                // this is a USC Northern Division community news post
                                // find the parent post based on the slug
                                $.ajax({
                                    url: baseUrl + '/posts?slug=' + story.slug,
                                    type: 'GET',
                                    success: function (posts) {
                                        if (posts.length > 0 && posts[0].featured_media && posts[0].featured_media != 0) {
                                            $.ajax({
                                                url: baseUrl + '/media/' + posts[0].featured_media,
                                                type: 'GET',
                                                async: false,
                                                success: function (data) {
                                                    story.media = data;
                                                    story.headerImage = story.media ? story.media.source_url : null;
                                                }
                                            });
                                        } else {
                                            story.headerImage = story.media ? story.media.source_url : null;
                                        }
                                    },
                                    fail: function () {
                                        story.headerImage = story.media ? story.media.source_url : null;
                                    }
                                });
                            } else {
                                story.headerImage = story.media ? story.media.source_url : null;
                            }
                        }
                    }

                    Promise.all(promises_stories)
                        .then(function () {
                            promisesDone();
                        })
                        .catch(function () {
                            promisesDone();
                        });

                    function promisesDone() {
                        symphony.storiesModule.wordpressStories = symphony.wordpressFeed.wordpressStories.concat(symphony.storiesModule.tmpLocalWordpressStories);
                        symphony.wordpressFeed.wordpressStories = JSON.parse(JSON.stringify(symphony.storiesModule.wordpressStories));

                        symphony.storiesModule.tmpLocalWordpressStories = [];

                        symphony.wordpressFeed.pageNumber = null;
                        symphony.wordpressFeed.sortAndRender(true);
                        callback();
                        symphony.wordpressFeed.waitingForResponse = false;
                    }
                });
            }
        } else {
            callback();
        }
    };

    symphony.addStoriesSlickTemplate = function ($container, dontUseCombinedList, storyIds) {
        if (symphony.storiesModule.allStories.length == 0) {
            symphony.storiesModule.allStories = dontUseCombinedList ? symphony.wordpressFeed.localStories.activeDocs : symphony.wordpressFeed.combinedActiveDocs;
        }

        var filteredList = JSON.parse(JSON.stringify(symphony.storiesModule.allStories));

        if (storyIds && storyIds.length > 0) {
            var matchedStoryIds = [];
            storyIds = JSON.parse(JSON.stringify(storyIds.split(',')));

            for (var i = 0; i < storyIds.length; i++ ) {
                var id = storyIds[i];

                for (var j = 0; j < filteredList.length; j++) {
                    var story = filteredList[j];
                    if (story.id == id) {
                        matchedStoryIds.push(story);
                    }
                }
            }
            filteredList = matchedStoryIds;
        }

        $container[0].classList.remove('local-loading');

        // Get first 3 or 6 stories in list
        filteredList = $(window).width() >= 1025 ? filteredList.slice(0, 6) : filteredList.slice(0, 3);

        // no stories in admin
        if (filteredList.length == 0 && document.body.classList.contains('admin-body')) {
            $container.html(symphony.strings['layout.noStoriesAvailableForSelection'] +' <a href="' + siteUrlAlias + '/admin/news">'+ symphony.strings['layout.pleaseCreateSomeStoriesFirst'] +'</a>');
        } else {
            $container.html('');
            // Eventually turns into combinedActiveDocs instead of wordpressFeed.localStories.activeDocs
            for (var i = 0; i < filteredList.length; i++) {
                var story = filteredList[i];
                $container.append(symphony.templates['storiesCarousel']({
                    story: story
                }));
            }

            if ($(window).width() >= 1025) {
                $container.slick({
                    infinite: true,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    dots: true
                });
            }
            else{
                $container.slick({
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true
                });
            }

            // add resize event
            if (UTIL) {
                var returnedFunction = UTIL.debounce(function () {
                    symphony.adjustResponsiveStories($container);
                }, 250);

                window.addEventListener('resize', returnedFunction);
            } else {
                $(window).resize(function () {
                    symphony.adjustResponsiveStories($container);
                });
            }
        }
    };

    symphony.adjustResponsiveStories = function ($container) {
        if ($(window).width() >= 1025) {
            $container.slick({
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 3,
                dots: true
            });
        } else {
            $container.slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true
            });
        }
    };
})();
